import { render } from "./cube-animation.vue?vue&type=template&id=e06b25d4"
import script from "./cube-animation.vue?vue&type=script&lang=js"
export * from "./cube-animation.vue?vue&type=script&lang=js"

import "./cube-animation.vue?vue&type=style&index=0&id=e06b25d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__